import { SET_DEALER } from './actionTypes'
import { DealerActionTypes } from './types'

const initialState = {
  dealerID: 0,
  stockDealerID: 0, 
  dealerName: '', 
  locationName: '',
  privacyPolicy: '',
  address: '',
  phone: '',
  website: '',
  terms: '',
  openingHours: []
}

export default (state = initialState, action: DealerActionTypes) => {
  switch (action.type) {
    case SET_DEALER:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
